import { type Dispatch, type SetStateAction } from 'react';

import type { IncidentViewType } from '@/types';

import FilterFooter from '@/components/Incidents/filter-footer';
import IncidentDetails from '@/components/Incidents/incident-details';
import IncidentFilters from '@/components/Incidents/incident-filters';
import IncidentsList from '@/components/Incidents/incidents-list';
import { INCIDENT_DETAILS, INCIDENT_FILTER } from '@/utils/constants';

interface IncidentContentRendererProps {
  viewType: IncidentViewType;
  selectedRoutes: { journeyId: string; lineNumber: string }[];
  selectedStations: string[];
  tempRoutes: { journeyId: string; lineNumber: string }[];
  setTempRoutes: Dispatch<SetStateAction<{ journeyId: string; lineNumber: string }[]>>;
  tempStations: string[];
  setTempStations: Dispatch<SetStateAction<string[]>>;
  activeFilterCount: number;
  onShowFilter: () => void;
  onApplyFilter: () => void;
  onClearFilter: () => void;
}

const IncidentContentRenderer = ({
  viewType,
  selectedRoutes,
  selectedStations,
  tempRoutes,
  setTempRoutes,
  tempStations,
  setTempStations,
  activeFilterCount,
  onShowFilter,
  onApplyFilter,
  onClearFilter,
}: IncidentContentRendererProps) => {
  if (viewType === INCIDENT_DETAILS) {
    return <IncidentDetails />;
  }

  if (viewType === INCIDENT_FILTER) {
    return (
      <div className="flex flex-col h-full">
        <div className="flex-1 min-h-0">
          <IncidentFilters
            selectedRoutes={tempRoutes}
            setSelectedRoutes={setTempRoutes}
            selectedStations={tempStations}
            setSelectedStations={setTempStations}
          />
        </div>
        <FilterFooter
          onApply={onApplyFilter}
          onClear={onClearFilter}
          count={tempRoutes.length + tempStations.length}
        />
      </div>
    );
  }

  return (
    <IncidentsList
      selectedRoutes={selectedRoutes}
      selectedStations={selectedStations}
      activeFilterCount={activeFilterCount}
      onShowFilter={onShowFilter}
    />
  );
};

export default IncidentContentRenderer;
